module.exports = __webpack_public_path__ + "static/media/white_ball.161fd731.svg";